import { render, staticRenderFns } from "./message-video.vue?vue&type=template&id=7fde8567&scoped=true"
import script from "./message-video.vue?vue&type=script&lang=ts"
export * from "./message-video.vue?vue&type=script&lang=ts"
import style0 from "./message-video.vue?vue&type=style&index=0&id=7fde8567&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fde8567",
  null
  
)

export default component.exports